// a selection opened by direct link may belong to another customer, so the API has to be asked for it
export const getSelectionIdFromUrl = () =>
  window.location.pathname.match(/\/selections\/([a-f\d]{24})\/?$/i)?.[1];
